export default function LoadingState({
  title = "Loading…",
}) {
  return (
    <div
      style={{
        color: "#64748b",
        fontWeight: 800,
        padding: 18,
        borderRadius: 12,
        background: "#ffffff",
        border: "1px solid #e2e8f0",
      }}
    >
      {title}
    </div>
  );
}